import axiosInstance from './axiosInstance';

export const postSuggestShipping = async (finnkode: string) =>
    axiosInstance
        .post(`/api/post/suggestShipping/${finnkode}`)
        .then((res) => res.status)
        .catch((err) => {
            if (err.response.status !== 401) throw new Error();
            return err.response.status;
        });




/**
 * makeSuggestion: 
 * 1. First we make a call to post the suggestion.
 * 2. If this is a success, we fetch the new UI text.
 * 3. If we get a 401, it means that the user is not logged in. If this is the case we redirect to log-in page.
 */
export const makeSuggestion = async (finnkode: string) =>
    axiosInstance.post(`/api/post/suggestShipping/${finnkode}`)
        .then(() => axiosInstance.get(`/api/get/getUi/${finnkode}`))
        .then(res => res.data)
        .catch(err => {
            if (err.response.status === 401) {
                const redirectUrl = window.location.href;
                window.location.href = `/auth/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
            }
        })
